module.exports = __webpack_public_path__ + "static/WEB0-8241b36f218cb386658459b29887a774.png";